import React, { Component } from 'react';
import { BaseURLDev, headers } from '../../../../../_utils/config';
import { 
   Table, Menu, Input, Segment, Icon, Button
} from 'semantic-ui-react';

import _ from 'lodash';
import printJS from 'print-js';
import { toIDR } from '../../../../../_utils/tocurrency';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import moment from 'moment'
import jsPDF from 'jspdf'
import swal from 'sweetalert'

export default class AnggaranRealisasiSKPD extends Component {
   constructor(props){
      super(props);
      this.state = {
         column: null,
         result: [],
         tmp: [],
         data_: [],
         direction: null,
         requests: true,
         query: ""
      }

      this.printDocument = this.printDocument.bind(this);
   }

   printDocument() {
      printJS({
         printable:'data_print', 
         type:'html', 
         showModal:true
      })
   }

   handleSort = clickedColumn => () => {
      const { column, result, direction } = this.state

      if (column !== clickedColumn) {
         this.setState({
            column: clickedColumn,
            result: _.sortBy(result, [clickedColumn]),
            direction: 'ascending',
         })

         return
      }

      this.setState({
         result: result.reverse(),
         direction: direction === 'ascending' ? 'descending' : 'ascending',
      })
   }


   componentWillMount = () => this.getTargetRealisasi()

   searchData(e){
      const query = (e.target.value).toLowerCase()
      const { data_ } = this.state
      this.setState({query: query});      
      if(query.length>0)
      {
         var results = [];
         for(let i=0; i<data_.length; i++) {
            for(let key in data_[i]) {
               if(typeof data_[i][key] === "string" && data_[i][key].toLowerCase().indexOf(query)!==-1){
                  results.push(data_[i]);
               }
            }
         }
         this.setState({
            result: results, 
            requests: false
         });      
      }
      else
      {
         this.setState({
            data_: this.state.tmp,
            result: this.state.tmp,
            requests: false
         })
      }
   }

   getTargetRealisasi(){
      this.setState({requests: true})
      fetch(`${BaseURLDev}/report/targetrealisasiskpd`, { method:'GET', headers })
      .then(response => {
         if(!response.ok){
            swal("Load data gagal", {icon: "error"})
            this.setState({result: [], tmp: [], data_: [], requests: false});
            return Promise.reject(response.statusText);
         }
         return response.json()
      })
      .then(resJSON => (
         this.setState({
            result: resJSON.data,
            data_: resJSON.data,
            tmp: resJSON.data,
            requests: false
         })
      ))
      
   }

   
   exportData(opt){
      if(opt==='excel'){
         this.exportMode().toCSV('print_data',`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
      }
      else if(opt==='pdf'){
         this.setState({is_print:true})
         this.exportToPDF(`${moment().format("DD_MM_YYYY_HH_mm_ss")}`)
      }
      else{
         printJS({
            printable: 'data_print',
            type: 'html',
            modalMessage:"Sedang memuat data...",
            showModal:true,
            maxWidth:'1300',
            font_size:'8pt',
            documentTitle:`${moment().format('DD-MM-YYYY--HH:mm:ss')}`,
            targetStyle: [
               'margin',
               'color',
               'border-collapse',
               'border-spacing',
               'border-style',
               'border-style',
               'margin-bottom',
               'background',
               'padding'
            ]
         })
      }
   }

   exportToPDF(file_name) {
      var pdf = new jsPDF('l', 'pt', 'legal');
      var source = document.getElementById("data_print");
      var margins = {
         top: 40,
         bottom: 60,
         left: 30,
         width: 1000
      };
      
      pdf.fromHTML(
         source, // HTML string or DOM elem ref.
         margins.left, // x coord
         margins.top, { // y coord
            'width': margins.width, // max width of content on PDF
         },

         function (dispose) {
            // dispose: object with X, Y of the last line add to the PDF 
            //          this allow the insertion of new lines after html
            pdf.save(`${file_name}.pdf`);
         }, margins
      );
      this.setState({is_print:false})         
      
   }

   exportMode(){
      return {
         _fallbacktoCSV: true,  
         toXLS: function(tableId, filename) {   
            this._filename = (typeof filename === 'undefined') ? tableId : filename;

            //var ieVersion = this._getMsieVersion();
            //Fallback to CSV for IE & Edge
            if ((this._getMsieVersion() || this._isFirefox()) && this._fallbacktoCSV) {
               return this.toCSV(tableId);
            } else if (this._getMsieVersion() || this._isFirefox()) {
               alert("Not supported browser");
            }

            //Other Browser can download xls
            var htmltable = document.getElementById(tableId);
            var html = htmltable.outerHTML;

            this._downloadAnchor("data:application/vnd.ms-excel" + encodeURIComponent(html), 'xls'); 
         },
         toCSV: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var csv = this._tableToCSV(document.getElementById(tableId));
            // Create a CSV Blob
            var blob = new Blob([csv], { type: "text/csv" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".csv");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'csv');      
            }
         },
         toPDF: function(tableId, filename) {
            this._filename = (typeof filename === 'undefined') ? tableId : filename;
            // Generate our CSV string from out HTML Table
            var pdf = document.getElementById(tableId);
            // Create a CSV Blob
            var blob = new Blob([pdf], { type: "text/pdf" });

            // Determine which approach to take for the download
            if (navigator.msSaveOrOpenBlob) {
               // Works for Internet Explorer and Microsoft Edge
               navigator.msSaveOrOpenBlob(blob, this._filename + ".pdf");
            } else {      
               this._downloadAnchor(URL.createObjectURL(blob), 'pdf');      
            }
         },
         _getMsieVersion: function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf("MSIE ");
            if (msie > 0) {
               // IE 10 or older => return version number
               return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            var trident = ua.indexOf("Trident/");
            if (trident > 0) {
               // IE 11 => return version number
               var rv = ua.indexOf("rv:");
               return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            var edge = ua.indexOf("Edge/");
            if (edge > 0) {
               // Edge (IE 12+) => return version number
               return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
         },
         _isFirefox: function(){
            if (navigator.userAgent.indexOf("Firefox") > 0) {
               return 1;
            }

            return 0;
         },
         _downloadAnchor: function(content, ext) {
            var anchor = document.createElement("a");
            anchor.style = "display:none !important";
            anchor.id = "downloadanchor";

            document.body.appendChild(anchor);

            // If the [download] attribute is supported, try to use it
            if ("download" in anchor) {
               anchor.download = this._filename + "." + ext;
            }
            anchor.href = content;
            anchor.click();
            anchor.remove();
         },
         _tableToCSV: function(table) {
            // We'll be co-opting `slice` to create arrays
            var slice = Array.prototype.slice;

            return slice
            .call(table.rows)
            .map(function(row) {
               return slice
               .call(row.cells)
               .map(function(cell) {
                  return '"t"'.replace("t", cell.textContent);
               })
               .join(",");
            })
            .join("\r\n");
         }
      }
   }

   render() {
      const { column, direction,requests, result } = this.state;
      const styletb = {
         borderCollapse:'collapse',
         borderSpacing:0,
         borderStyle:'solid',
         width:'100%',
      }
      return (
         <div>
               <div>                     
                  <Menu>
                     <Menu.Item>
                        <Button color='blue' size="small" onClick={()=>this.exportData('print')}> 
                           <p><Icon name='print' className='left floated' />Preview</p>
                        </Button>
                     </Menu.Item>
                     <Menu.Item>
                        <h4>Perbandingan Target dan Realisasi SKPD</h4>
                     </Menu.Item>
                     <Menu.Item position="right">
                        <Input type="text"
                           icon="search"
                           placeholder="Pencarian..."
                           autoFocus 
                           value={this.state.query}
                           style={{width:'300px'}}
                           onChange={this.searchData.bind(this)} />
                  </Menu.Item>
                  </Menu>
                  <Segment loading={requests}>
                     {requests ? 
                        <Table size='small'>
                           <Table.Body>
                              <Table.Row>
                                 <Table.Cell>
                                    <SkeletonTheme color="#202020" highlightColor="#444">
                                       <Skeleton count={7} />
                                    </SkeletonTheme>
                                 </Table.Cell>
                                 <Table.Cell>
                                    <SkeletonTheme color="#202020" highlightColor="#444">
                                       <Skeleton count={7} />
                                    </SkeletonTheme>
                                 </Table.Cell>
                                 <Table.Cell>
                                    <SkeletonTheme color="#202020" highlightColor="#444">
                                       <Skeleton count={7} />
                                    </SkeletonTheme>
                                 </Table.Cell>
                                 <Table.Cell>
                                    <SkeletonTheme color="#202020" highlightColor="#444">
                                       <Skeleton count={7} />
                                    </SkeletonTheme>
                                 </Table.Cell>
                              </Table.Row>
                           </Table.Body>
                        </Table> :
                        <div id="data_print">
                           <Table border='1' style={styletb} size='small' id="print_data" width="100%">
                              <Table.Header>
                                 <Table.Row>
                                    <Table.HeaderCell>No.</Table.HeaderCell>
                                    <Table.HeaderCell sorted={column === 'kode_skpd' ? direction : null} onClick={this.handleSort('kode_skpd')}>Kode SKPD</Table.HeaderCell>
                                    <Table.HeaderCell style={{width:'40%'}} sorted={column === 'skpd' ? direction : null} onClick={this.handleSort('skpd')}>SKPD</Table.HeaderCell>
                                    <Table.HeaderCell sorted={column === 'target' ? direction : null} onClick={this.handleSort('target')}>Target</Table.HeaderCell>
                                    <Table.HeaderCell sorted={column === 'realisasi' ? direction : null} onClick={this.handleSort('realisasi')}>Realisasi</Table.HeaderCell>
                                 </Table.Row>
                              </Table.Header>
                              <Table.Body>
                                 {result.length===0 && 
                                    <Table.Row>
                                       <Table.Cell colSpan="6">Data tidak ditemukan</Table.Cell>                           
                                    </Table.Row>}
                                 {result.map((item,i) => (
                                    <Table.Row key={i}>               
                                       <Table.Cell>{i+1}.</Table.Cell>
                                       <Table.Cell>{item.kode_skpd}</Table.Cell>
                                       <Table.Cell style={{width:'40%'}}>{item.skpd}</Table.Cell>
                                       <Table.Cell>{toIDR(item.target)}</Table.Cell>
                                       <Table.Cell>{toIDR(item.realisasi)}</Table.Cell>
                                    </Table.Row>
                                 ))}
                              </Table.Body>                  
                           </Table>
                        </div>
                     }        
                  </Segment>                   
               </div>
         </div>
      );
   }
}


// WEBPACK FOOTER //
// ./src/components/Content/views/admin/_report/AnggaranRealisasiSKPD.js